import { useState } from 'react';

const   TeamSection = () => {
  const [activeTab, setActiveTab] = useState('leadership');

  const leadershipTeam = [
    // {
    //   name: 'PRADIP PARIDA',
    //   role: 'Founder & CEO',
    //   image: '/assets/team/leadership-1.svg',
    //   // company: 'ZIPNOSIS',
    // },
    {
      name: 'VARUN BANSAL',
      role: 'Chief Business Officer',
      image: '/assets/team/leadership-2.svg',
      // company: 'ZIPNOSIS',
    },
    {
      name: 'SMARANIKA MOHANTY',
      role: 'Head Of Quality',
      image: '/assets/team/leadership-3.svg',
      // company: 'ZIPNOSIS',
    },
    {
      name: 'NAGARAJU PALLANTI',
      role: 'Practice Head',
      image: '/assets/team/leadership-4.svg',
      // company: 'ZIPNOSIS',
    },
  ];

  const advisoryBoard = [
    {
      name: 'Bhanu Prakash',
      role: 'Technology',
      image: "/assets/team/advisory-1.svg",
      // company: 'ZIPNOSIS',
    },
    {
      name: 'Bohitesh Misra',
      role: 'Strategy',
      image: '/assets/team/advisory-2.svg',
    },
    {
      name: 'Dr. Dwijendra Prasad',
      role: 'Medical & Clinical Advisory',
      image: '/assets/team/advisory-3.svg',
    },
    {
      name: 'Yadvinder Singh',
      role: 'Strategy',
      image: '/assets/team/advisory-4.svg',
    },
  ];

  const currentTeam = activeTab === 'leadership' ? leadershipTeam : advisoryBoard;

  return (
    <section
      className="py-12 md:py-16 bg-light"
    >
      <div className="container mx-auto px-4">
        {/* Title */}
        <div className="text-center mb-10">
          <div className="inline-block relative">
          <h2 className="font-bold  mb-1">
            The Minds Driving <span className=''>Our Mission</span>
            <span className="absolute bottom-0 left-1/2 right-0 h-0.5 primary-bg"></span>
          </h2>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex justify-left mb-8">
          <div className="inline-flex border-b border-gray-400">
            <button
              onClick={() => setActiveTab('leadership')}
              className={`px-8 py-3 font-medium transition-all ${
                activeTab === 'leadership'
                  // ? ' border-b-2 border-white'
                  // : 'text-black hover:text-black-200'

                  ? ' border-b-2 primary-border-bottom'
                  : 'secondary-text hover:'
              }`}
            >
              Leadership
            </button>
            <span className="text-black-400 self-center mx-2">|</span>
            <button
              onClick={() => setActiveTab('advisory')}
              className={`px-8 py-3  font-medium transition-all ${
                activeTab === 'advisory'
                  ? ' border-b-2 primary-border-bottom'
                  : 'secondary-text hover:'
              }`}
            >
              Advisory Board
            </button>
          </div>
        </div>

        {/* Team Grid - Fixed height container */}
        <div className="min-h-[300px]">
          {activeTab === 'leadership' ? (
            // Leadership Cards - Original style with overlay
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {currentTeam.map((member, index) => (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-lg shadow-lg transition-transform duration-300 hover:scale-105 h-[250px]"
                >
                  {/* Image */}
                  <div className="w-full h-full overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>

                  {/* Overlay with Info */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-4">
                    <h3 className="text-white font-bold  mb-1">
                      {member.name}
                    </h3>
                    <p className="text-gray-300 ">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // Advisory Board Cards - New card style with circular images
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              {currentTeam.map((member, index) => (
                <div
                  key={index}
                  className="bg-gray-700/30 backdrop-blur-sm rounded-xl p-6 text-center transition-all duration-300 hover:bg-gray-700/40 hover:scale-105 shadow-lg h-[250px] flex flex-col justify-between"
                >
                  <div>
                    {/* Circular Image */}
                    <div className="flex justify-center mb-3">
                      <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-gray-600 shadow-xl">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>

                    {/* Member Info */}
                    <h3 className="text-white font-bold  mb-2">
                      {member.name}
                    </h3>
                    <p className=" mb-3">
                      {member.role}
                    </p>
                  </div>

                  {/* Company Logo */}
                  <div className="pt-4 border-t border-gray-600">
                    <p className="text-gray-400 tracking-widest font-semibold">
                      {member.company}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;